module.exports = __webpack_public_path__ + "media/images/pic/teachers/anna-sielawko-23bf6142da1be2ac9e7282b7e466c207.png";